import {
  SR_API_ACTION_JOB_UPDATE_STATUS,
} from 'api/actionTypes';

export default async function updateJobStatus(
  { state, apiClient },
  { jobId, status }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_JOB_UPDATE_STATUS,
    state: state,
    payload: {
      jobId,
      status,
    },
  });
}
